<template>
  <div class="price-list" style="border:1px solid #dedede;margin-bottom:15px;border-radius:5px;">
    <div
      class="text-xs-center"
      @click="showProduct = !showProduct"
      style="padding:5px;border-bottom:1px solid #eee;background:white;border-top-left-radius:5px;border-top-right-radius:5px;cursor:pointer;"
    >
      {{ $t("Tab to view your shopping cart") }}
      <v-icon v-if="showProduct">mdi-chevron-up</v-icon>
      <v-icon v-else>mdi-chevron-down</v-icon>
    </div>
    <div class="row" style="border-bottom:1px solid #dedede;" v-show="showProduct">
      <cart-item
        v-for="(product, pindex) in cart"
        :key="'product_' + pindex"
        :product="product"
      ></cart-item>
    </div>
    <v-layout wrap row style="padding:5px;border-bottom:1px solid #dedede;background: white;">
      <v-flex xs6>{{ $t("Price") }}</v-flex>
      <v-flex xs6 class="price text-right">{{ currencySign }}{{ total | decimalFormat }}</v-flex>
    </v-layout>
    <template v-if="discount">
      <v-layout wrap row style="padding:5px;border-bottom:1px solid #dedede;background: white;">
        <v-flex xs6>{{ $t("Discount") }}</v-flex>
        <v-flex xs6 class="price text-right"
          >-{{ currencySign }}{{ discount | decimalFormat }}</v-flex
        >
      </v-layout>
      <v-layout wrap row style="padding:5px;border-bottom:1px solid #dedede;background: white;">
        <v-flex xs6>{{ $t("Subtotal") }}</v-flex>
        <v-flex xs6 class="price text-right"
          >{{ currencySign }}{{ totalincludediscount | decimalFormat }}</v-flex
        >
      </v-layout>
    </template>

    <v-layout
      wrap
      row
      style="padding:5px;border-bottom:1px solid #dedede;background: white;"
      v-if="isCustomize || shippingType || additionalproduct_charge != 0 || isBearhouse || isCDS"
    >
      <v-flex xs6>
        {{ $t("Shipping fee") }}
        <span v-if="isKhaiwhan">{{ "(จ่ายกับพนักงานขนส่ง)" }}</span>
      </v-flex>
      <v-flex xs6 class="price text-right">
        <template v-if="isCDS">
          <div v-if="cdsshippingprice">
            {{ currencySign }}{{ cdsshippingprice | decimalFormat }}
          </div>
          <div v-else>Free</div>
        </template>

        <template
          v-else-if="
            isGaiGao ||
              isBearhouse ||
              isKhaiwhan ||
              ['purelife', 'gaigacha', 'kanom', 'fastdeli'].includes(pageProfile.type)
          "
        >
          <template v-if="ableToBuy">
            {{
              discountShipping === 0
                ? `${currencySign + (customerShippingPrice - discountShipping)}`
                : voucher && voucher.discountship > 0 && shippingPrice > 0
                ? currencySign + customerShippingPrice
                : "Free"
            }}</template
          >
          <template v-else
            >ไม่สามารถจัดส่งได้</template
          >
        </template>
        <template v-else-if="shippingType">
          <template v-if="shippingType.value != 0">
            <template v-if="isSmoothE">
              <template v-if="total < 500"
                >{{ currencySign }}{{ shippingType.value | decimalFormat }}</template
              >
              <template v-else
                >Free</template
              >
            </template>
            <template v-else>
              {{
                discountShipping === 0
                  ? `${currencySign + (shippingType.value - discountShipping)}`
                  : voucher && voucher.discountship > 0 && shippingPrice > 0
                  ? currencySign + shippingType.value
                  : "Free"
              }}
            </template>
          </template>
          <template v-else
            >Free</template
          >
        </template>
        <template v-else
          >{{ currencySign }}{{ 0 | decimalFormat }}</template
        >
      </v-flex>
    </v-layout>

    <v-layout
      wrap
      row
      style="padding:5px;border-bottom:1px solid #dedede;background: white;"
      v-if="voucher && voucher.discountship > 0 && shippingPrice > 0"
    >
      <v-flex xs6>
        {{ $t("Discount") + " " + $t("Shipping fee") }}
      </v-flex>
      <v-flex xs6 class="price text-right">
        -{{ currencySign }}{{ discountShipping | decimalFormat }}
      </v-flex>
    </v-layout>

    <v-layout
      wrap
      row
      class="totalprice"
      style="padding:5px;background: white;border-bottom-left-radius:5px;border-bottom-right-radius:5px;"
    >
      <v-flex xs6>{{ $t("Total") }}</v-flex>

      <v-flex xs6 class="price text-right"
        >{{ currencySign }}{{ totalPrice | decimalFormat }}</v-flex
      >
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CartItem from "@/components/payment/CartItem.vue";

export default {
  props: {
    total: {
      default: undefined,
    },
    totalincludediscount: {
      default: undefined,
    },
    discount: {
      default: undefined,
    },
    shippingType: {
      default: undefined,
    },
    additionalproduct_charge: {
      default: undefined,
    },
    bearhouseshippingprice: {
      default: undefined,
    },
    cdsshippingprice: {
      default: undefined,
    },
    khaiwhanshippingprice: {
      default: undefined,
    },
    customerShippingPrice: {
      default: undefined,
    },
    isCustomize: {
      default: false,
    },
    ableToBuy: {
      default: true,
    },
    voucher: {
      default: undefined,
    },
  },
  data: function() {
    return {
      showProduct: false,
    };
  },
  mounted() {
    if (this.pageProfile.type == "chillpainai") this.showProduct = true;
  },
  components: {
    CartItem,
  },
  computed: {
    shippingPrice() {
      var cost = 0;
      if (
        (this.isCustomize ||
          this.shippingType ||
          this.additionalproduct_charge != 0 ||
          this.isBearhouse ||
          this.isCDS) &&
        this.pageProfile.type != "nvbb"
      ) {
        if (this.isCDS) cost = this.cdsshippingprice;
        else if (
          this.isGaiGao ||
          this.isBearhouse ||
          this.isKhaiwhan ||
          ["purelife", "gaigacha", "kanom", "fastdeli"].includes(this.pageProfile.type)
        )
          cost = this.customerShippingPrice;
        else if (this.shippingType && this.shippingType.value) {
          cost = this.shippingType.value;
        }
        return cost;
      } else {
        return false;
      }
    },
    discountShipping() {
      if (this.shippingPrice && this.voucher) {
        if (this.voucher.freeship) {
          return this.shippingPrice;
        } else if (this.shippingPrice > this.voucher.discountship) {
          return this.voucher.discountship;
        } else {
          return this.shippingPrice;
        }
      }
      return 0;
    },
    isGaiGao() {
      return this.pageProfile && this.pageProfile.type == "gaigao";
    },
    isKhaiwhan() {
      return this.pageProfile && this.$store.state.khaiwhan.includes(this.pageProfile.pageid);
    },
    isCDS() {
      return this.pageProfile && this.$store.state.cds.includes(this.pageProfile.pageid);
    },
    isSmoothE() {
      return this.pageProfile && this.pageProfile.type == "smoothe";
    },
    ...mapGetters({
      cart: "getCart",
      currentLang: "currentLang",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
    }),

    isBearhouse() {
      return this.pageProfile && this.$store.state.bearhouse.includes(this.pageProfile.pageid);
    },
    currencySign: function() {
      if (this.pageProfile && this.pageProfile.pageid == "402026927063253") {
        return "$";
      } else if (this.pageProfile && this.pageProfile.pageid == "751241271893504") {
        return "K";
      } else {
        return "฿";
      }
    },
    totalPrice: function() {
      var price = 0;
      if (this.isCDS) {
        price = this.totalincludediscount + this.cdsshippingprice;
      } else if (this.isBearhouse || this.isKhaiwhan || this.isGaiGao) {
        price = this.totalincludediscount + this.customerShippingPrice;
      } else if (this.shippingType) {
        if (this.isSmoothE && this.totalincludediscount >= 500) return this.totalincludediscount;
        price = this.totalincludediscount + this.shippingType.value;
      } else {
        price = this.totalincludediscount;
      }

      return price - this.discountShipping;
    },
  },
};
</script>

<style lang="scss" scoped></style>
